import { render } from "./ListDeliveryMan.vue?vue&type=template&id=32f539cc&scoped=true"
import script from "./ListDeliveryMan.vue?vue&type=script&lang=js"
export * from "./ListDeliveryMan.vue?vue&type=script&lang=js"

import "./ListDeliveryMan.vue?vue&type=style&index=0&id=32f539cc&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f539cc"]])

export default __exports__